/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { enumType } from "@pagopa/ts-commons/lib/types";
import * as t from "io-ts";

export enum PaymentCanceledStatusFaultEnum {
  "PAA_PAGAMENTO_ANNULLATO" = "PAA_PAGAMENTO_ANNULLATO"
}

/**
 * Fault codes for errors related to payment attempts that cause conflict with the current payment status,
 * such as a duplicated payment attempt or a payment attempt made while another attempt is still being processed.
 * Should be mapped to 409 HTTP status code.
 * For further information visit https://docs.pagopa.it/gestionedeglierrori/struttura-degli-errori/fault-code.
 * Possible fault codes are:
 * - `PAA_PAGAMENTO_ANNULLATO`
 */

export type PaymentCanceledStatusFault = t.TypeOf<
  typeof PaymentCanceledStatusFault
>;
export const PaymentCanceledStatusFault = enumType<
  PaymentCanceledStatusFaultEnum
>(PaymentCanceledStatusFaultEnum, "PaymentCanceledStatusFault");
